<template>
<md-card>
    <md-card-header>
        <md-card-header-text>
            Cálculos del instalador
        </md-card-header-text>
    </md-card-header>
    <md-card-content>
        <md-table>
            <md-table-row>
                <md-table-cell>
                    Porcentaje de primer pago
                </md-table-cell>
                <md-table-cell>
                    <span class="copy">{{finance.supplier_first_payment_percentage * 100}} </span> %
                </md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>
                    Comisión por fondeo con IVA
                </md-table-cell>
                <md-table-cell>
                    <span class="copy">{{finance.fund_comission |currency}}</span>
                </md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>
                    1er pago bruto
                </md-table-cell>
                <md-table-cell>
                    <span class="copy">{{finance.installer_first_payment |currency}}</span>
                </md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>
                    2ndo pago
                </md-table-cell>
                <md-table-cell>
                    <span class="copy">{{finance.installer_second_payment|currency}}</span>
                </md-table-cell>
            </md-table-row>
        </md-table>
        <div class="row">
            <div class="col-md-12">
                <slot name="invoice_supplier_pdf"></slot>
                <slot name="invoice_supplier_xml"></slot>
            </div>
        </div>
    </md-card-content>
</md-card>
</template>

<script>
    export default {
        name: "ProjectEconomySupplierValues",
        props: {
            finance: {
                type: Object,
                required: true,
                default: () => ({})
            }
        }
    }
</script>

<style scoped>

</style>
